<template>
    <div class="card">
      <div class="card-header pb-0 d-flex">
        <h6>Employee table</h6>
        <input
          type="text"
          v-model="searchQuery"
          placeholder="Search..."
          class="form-control mb-3 ms-auto"
          style="max-width: 250px; "
        />
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder">
                  Name
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder ps-2">
                  Detail
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">
                  Basic
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">
                  OT
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">
                  Date Created
                </th>
                <!-- <th class="text-secondary"></th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(employee,index) in paginatedEmployee" :key="index">
                <td>
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-0 text-sm">{{ (currentPage-1)*10 + index +1 }}. {{ employee.name }}</h6>
                      <p class="text-xs text-secondary mb-0">
                        {{ employee.empcode}}
                      </p>
                    </div>
                  </div>
                </td>
                <td>
                  <h6 class="text-xs font-weight-bold mb-0">{{ employee.contact }}</h6>
                  <p class="text-xs text-secondary mb-0">{{ employee.race_desc }}</p>
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">Basic: RM {{ employee.basic }} /Hour</p>
                  <p class="text-xs font-weight-bold mb-0">Luar: RM {{ employee.basic_luar }} /Hour</p>
                  <p class="text-xs font-weight-bold mb-0">Racun: RM {{ employee.basic_racun }} /Hour</p>
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">OT: RM {{ employee.ot }} /Hour</p>
                  <p class="text-xs font-weight-bold mb-0">Luar: RM {{ employee.ot_luar }} /Hour</p>
                  <p class="text-xs font-weight-bold mb-0">Racun: RM {{ employee.ot_racun }} /Hour</p>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold" >
                    {{ employee.created_at }}
                    </span>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- Pagination Controls -->
          <hr />
          <div class="pagination-container">
            <div>
              <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-info">Previous</button>
              <span class="form-control-label" style="padding:10px"> Page {{ currentPage }} of {{ totalPages }} </span>
              <button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-info">Next</button>
            </div>
            
            <span class="form-control-label total-rows">Total {{ totalRows }} entries </span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
import axios from 'axios';

export default {
  name:'EmployeeSelect',
  data(){
    return {
      totalRows: 0,
      currentPage: 0,
      perPage: 10,
      searchQuery:'',
      employeeList: []
    }
  },
  mounted(){
    this.getEmployeeList();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.employeeList.length / this.perPage);
    },
    paginatedEmployee() {
      const start = (this.currentPage - 1) * this.perPage;
      let query = this.searchQuery.toLowerCase();

      // Filter employee by checking all properties in each row
      let filtered = this.employeeList.filter(employee => {
        return Object.values(employee).some(value =>
          String(value).toLowerCase().includes(query)
        );
      });
      return filtered.slice(start, start + this.perPage);
    }
  },
  methods: {

    getEmployeeList(){
        // console.log(localStorage.getItem('token'));
        // var mythis = this;
        axios.get('payroll/listAllEmployee')
            .then(res => {
              // console.log(res.data.customer);
                this.employeeList = res.data.employeeList;
                this.totalRows = res.data.employeeList.length;
                this.currentPage = 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Name, Company, Contact, State and Address is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
  },
}
</script>